import { CellTable } from "@/atoms"
import { ScanStateIndicator } from "../ScanStateIndicator"

import type { ImageTagCellComponent } from "."

export const ImageTagCell: ImageTagCellComponent = (value, record) => (
  <ScanStateIndicator scanState={record.scanState}>
    {CellTable(value)}
  </ScanStateIndicator>
)
